import React from "react";
import styled from "styled-components";
import { LuChevronDown } from "react-icons/lu";
import { IoLogoWhatsapp } from "react-icons/io";

const perguntasRespostas = [
  {
    pergunta: "Como vejo meus agendamentos do dia?",
    resposta: "Vá até a página inicial do painel e você verá todos os agendamentos confirmados para o dia atual. Use os filtros de data para navegar."
  },
  {
    pergunta: "Como altero meus horários de trabalho?",
    resposta: "Acesse o menu lateral e clique em 'Agenda'. Lá você poderá editar seus horários de atendimento e adicionar intervalos."
  },
  {
    pergunta: "Como vejo minha comissão acumulada?",
    resposta: "No Painel do Barbeiro na página inicial ou na aba 'Comissão', você pode visualizar sua comissão diária, semanal, mensal e dos últimos 30 dias."
  },
  {
    pergunta: "Como sei quais serviços eu atendo?",
    resposta: "No Painel do Proprietário, na aba 'Equipe', seu card indica todos os serviços que você realiza. Caso deseje alterar, solicite ao proprietário da barbearia."
  },
  {
    pergunta: "Esqueci minha senha, o que faço?",
    resposta: "Entre em contato com nosso Suporte"
  },
];

/* ===== Mantém DESKTOP igual; só muda no mobile via @media ===== */
const Container = styled.main`
  /* desktop original */
  flex: 1;
  padding: 2rem 4rem;
  width: 100%;
  margin: 0 auto;
  background: #f3f7ff;
  min-height: 100vh;

  /* mobile */
  @media (max-width: 640px) {
    padding: 1rem;
  }
`;

const Titulo = styled.h1`
  /* desktop original */
  font-size: 2.2rem;
  margin-bottom: 2rem;
  color: #1F1A40;

  /* mobile */
  @media (max-width: 640px) {
    font-size: 1.6rem;
    margin-bottom: 1rem;
  }
`;

const PerguntaWrapper = styled.div`
  background: #fff;
  border-radius: 1rem;
  margin-bottom: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
`;

const Pergunta = styled.button`
  /* desktop original */
  width: 100%;
  padding: 1.2rem 1.5rem;
  font-size: 1.1rem;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: none;
  background: transparent;
  color: #333;
  cursor: pointer;

  /* mobile */
  @media (max-width: 640px) {
    padding: 1rem 1rem;
    font-size: 1rem;
  }
`;

const Resposta = styled.div`
  padding: 0 1.5rem 1.5rem;
  font-size: 1rem;
  color: #555;

  @media (max-width: 640px) {
    padding: 0 1rem 1rem;
    font-size: 0.95rem;
    line-height: 1.5;
  }
`;

const WhatsButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  max-width: 520px;
  gap: 20px;
  margin-top: 2rem;
  padding: 1rem 1.8rem;
  font-size: 1.1rem;
  font-weight: bold;
  background-color: #3a79ed;
  color: white;
  border-radius: 10px;
  text-align: center;
  text-decoration: none;
  transition: background 0.3s;

  &:hover { background-color: #2b5cb6; }

  @media (max-width: 640px) {
    width: 100%;
    padding: 0.9rem 1.2rem;
    font-size: 1rem;
  }
`;

const Icon = styled(LuChevronDown)`
  transition: transform 0.25s ease;
  transform: ${({ $open }) => ($open ? "rotate(180deg)" : "rotate(0deg)")};
`;

const FAQItem = ({ pergunta, resposta }) => {
  const [aberto, setAberto] = React.useState(false);

  return (
    <PerguntaWrapper>
      <Pergunta onClick={() => setAberto((a) => !a)}>
        {pergunta}
        <Icon size={20} $open={aberto} />
      </Pergunta>
      {aberto && <Resposta>{resposta}</Resposta>}
    </PerguntaWrapper>
  );
};

const AjudaBarbeiro = () => {
  return (
    <>
      <Container>
        {perguntasRespostas.map((item, index) => (
          <FAQItem key={index} pergunta={item.pergunta} resposta={item.resposta} />
        ))}

        <WhatsButton
          href="https://wa.me/5511976299276"
          target="_blank"
          rel="noopener noreferrer"
        >
          <IoLogoWhatsapp />
          Entre em contato conosco pelo WhatsApp
        </WhatsButton>
      </Container>
    </>
  );
};

export default AjudaBarbeiro;
